<template>
  <div :class="{ 'progress-bar green stripes': true, 'narrow-height': narrow }" 
    :style="`width: ${width ? width : (allowNullWidth ? 0 : 100)}px;`">
    <span :style="`width: ${realPercent}%;`"></span>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';

@Component({
  name: 'PaymentProgress'
})
export default class PaymentProgress extends Vue {
  @Prop({ required: true }) readonly percent!: number;
  @Prop({ required: false, default: 0 }) width!: number;
  @Prop({ default: false }) narrow!: boolean;
  @Prop({ default: false }) allowNullWidth!: boolean;

  get realPercent(): number {
    return this.percent > 100 ? 100 : this.percent
  }
}
</script>

<style lang="scss" scoped>
:host {
    display: inline-block;
}

.progress-bar {
    background-color: white;
    height: 16px;
    // width: 100px;
    border: 1px solid black;
}

.progress-bar span {
    display: inline-block;
    height: 14px;
    -webkit-transition: width .4s ease-in-out;
    -moz-transition: width .4s ease-in-out;
    -ms-transition: width .4s ease-in-out;
    -o-transition: width .4s ease-in-out;
    transition: width .4s ease-in-out;
}

.narrow-height {
    height: 9px !important;
    border-color: black;
}

.narrow-height span {
    height: 7px !important;
    display: block;

    -webkit-transition: width .4s ease-in-out;
    -moz-transition: width .4s ease-in-out;
    -ms-transition: width .4s ease-in-out;
    -o-transition: width .4s ease-in-out;
    transition: width .4s ease-in-out;
}

.blue span {
    background-color: #34c2e3;
}

.green span {
    background-color: $primary;
}
</style>
